import React, { useState } from 'react';

import { SkinTheme } from '../../design/models/SkinTheme';
import { SkinThemeConsumer } from '../../shared/SkinThemeContext';
import User from '../models/User';
import VerifyEmail from './VerifyEmail';
import VerifyEmailCodeExpired from './VerifyEmailCodeExpired';
import VerifyEmailFail from './VerifyEmailFail';
import VerifyEmailResult from '../models/VerifyEmailResult';
import VerifyEmailSuccess from './VerifyEmailSuccess';

const VerifyEmailContainer = () => {
  const [result, setResult] = useState<VerifyEmailResult>();
  const [user, setUser] = useState<User>(); // * used for code expired case
  const handleVerify = (result: VerifyEmailResult, user: User) => {
    setUser(user);
    setResult(result);
  };

  return (
    <SkinThemeConsumer>
    {
      (themeOptions: SkinTheme) => (
        <div className="membership-content">
        {
          result === undefined
          &&
          <VerifyEmail
            onVerify={handleVerify}
          />
        }
        {
          result === VerifyEmailResult.SUCCESS
          &&
          <VerifyEmailSuccess />
        }
        {
          result === VerifyEmailResult.ERROR
          &&
          <VerifyEmailFail />
        }
        {
          (result === VerifyEmailResult.CODE_EXPIRED && user)
          &&
          <VerifyEmailCodeExpired
            email={user.email}
            username={user.username}
          />
        }
        </div>
      )
    }
    </SkinThemeConsumer>
  )
}

export default VerifyEmailContainer;
